import React, { useState, useEffect } from 'react'
import { InputEmpresa, InputSimNao } from '../../../../components/InputsAutoComplete'
import { HeaderCadastro } from '../../../../components/Headers'
import { ModalCadastro } from '../../../../components/Modais'
import { Formik, Form } from 'formik'
import { InputPadrao, InputDatePicker, InputSwitch } from '../../../../components/Inputs'
import { BotaoPadrao } from '../../../../components/Botoes'
import Yup, { validaData, dataMenorAtual, periodoData } from '../../../../util/Validacoes'
import { removeAcentos } from '../../../../util/FuncoesComuns'
import Atalho from '../../../../util/Atalho'
import moment from 'moment'

const Cadastro = props => {
    const [pesquisa, setPesquisa] = useState('')
    const [msgBotao, setMsgBotao] = useState('Adicionar')
    const [salvando, setSalvando] = useState(false)

    const emptyValues = {

    }

    const [valoresIniciais, setValoresIniciais] = useState(emptyValues)
    const Submit = (socioEmpresa, { resetForm }) => {
        setSalvando(true);
        let copiaDependentes = [...props.data]

        if (socioEmpresa.verificador) {
            let index = copiaDependentes.findIndex(x => x.verificador === socioEmpresa.verificador)
            copiaDependentes[index] = socioEmpresa
        }
        else {
            socioEmpresa.verificador = Math.random()
            copiaDependentes.push(socioEmpresa)
        }

        props.setData(copiaDependentes)
        resetForm({})

        if (msgBotao === 'Alterar')
            props.setAbrirModal(!props.abrirModal)

        setSalvando(false)
    }
    const Delete = index => {
        let copiaDependentes = [...props.data]
        copiaDependentes.splice(index, 1);
        props.setData(copiaDependentes)
    }

    return (
        <>
            <HeaderCadastro
                titulo={'Sócio da Empresa'}
                pesquisa={true}
                valorPesquisa={pesquisa}
                onChangePesquisa={pesquisa => setPesquisa(pesquisa)}
                classeChildren='space-between-100' >
                <BotaoPadrao
                    type='button'
                    click={_ => {
                        let fatura ={ value: true, label: 'Sim' }
                        setValoresIniciais({ empresa: '', data_inicial:'', data_final: '', fatura_empresa:fatura })
                        props.setAbrirModal(!props.abrirModal);
                        setMsgBotao('Adicionar')
                    }}
                    classe='btn-primary primary p-5rem height-auto m-r-15'
                    texto={<><span> Adicionar</span> <span class='icon-Users fw'>+</span></>} />
            </HeaderCadastro>
            <div className='card mb-20'>
                <div className='card-body'>
                    <table className='table tabela-endereco table-responsive-md table-striped tabela' >
                        <thead>
                            <tr>
                                <th style={{ width: '5%' }}>#</th>
                                <th style={{ width: '45%' }}>Empresa</th>
                                <th style={{ width: '15%' }}>Data Entrada</th>
                                <th style={{ width: '15%' }}>Data Saída</th>
                                <th style={{ width: '5%'}}> Fatura Empresa?</th>
                                <th style={{ width: '20%' }} className='text-center'>Ações</th>
                            </tr>
                        </thead>
                        <tbody>
                            { }
                            {props.data.length ?
                                props.data.filter(x => removeAcentos(x.empresa.label.toLowerCase()).includes(removeAcentos(pesquisa.toLowerCase())))
                                    .map((dependente, index) =>
                                        <tr>
                                            <td>{index + 1}</td>
                                            <td>{dependente.empresa.label}</td>
                                            <td>{dependente.data_inicial}</td>
                                            <td>{dependente.data_final}</td>
                                            <td>{dependente.fatura_empresa.label}</td>
                                            <td className='text-center'>
                                                <span className='icon-consulta icon-Pen'
                                                    onClick={_ => { setValoresIniciais(dependente); props.setAbrirModal(true); setMsgBotao('Alterar') }} />
                                                <span className='icon-consulta icon-Column-2' onClick={target => Delete(index)} />
                                            </td>
                                        </tr>
                                    ) : <tr><td colspan='6' className='text-center'>Nenhum Registro Cadastrado</td></tr>}
                        </tbody>
                    </table>
                </div>
            </div>
            <ModalCadastro titulo={'Dados na Empresa'} show={props.abrirModal} setShowModal={props.setAbrirModal}>
                <Formik
                    enableReinitialize={true}
                    initialValues={valoresIniciais}
                    validationSchema={Yup.object({
                        id: Yup.string().nullable(),
                        empresa: Yup.string().nullable().required(),
                        data_inicial: Yup.string().nullable().required().test('Data Início', 'Data inválida!', function (value) { return validaData(this.parent.data_inicial) }).test('Data Inicial', 'Data inicial deve ser menor ou igual a Data Final!', function (value) { return periodoData(this.parent.data_inicial, this.parent.data_final) }),
                        data_final: Yup.string().nullable().test('Data Final', 'Data inválida!', function (value) { return validaData(this.parent.data_final) }),
                    })}
                    onSubmit={Submit}>
                    {propsFormik => <Form>
                        <div className='modal-body-cadastro'>
                            <InputPadrao label='Id' name='id' type='hidden' obrigatorio={false} />
                            <InputEmpresa label="Empresa" name="empresa" placeholder="Empresa" obrigatorio={true} classeTooltip={'tooltip-input-modal'} propsFormik={propsFormik} autoFocus focarAposSubmit={true} />
                            <InputDatePicker label="Data Inicial" name="data_inicial" type="text" classeTooltip={'tooltip-input-modal'} setarValor={value => { propsFormik.setFieldValue("data_inicial", value) }} placeholder="Data Inicial" obrigatorio={true} />
                            <InputDatePicker label="Data Final" name="data_final" type="text" classeTooltip={'tooltip-input-modal'} setarValor={value => { propsFormik.setFieldValue("data_final", value) }} placeholder="Data Final" />
                            <InputSimNao
                                label='Fatura Empresa?'
                                name='fatura_empresa'
                                obrigatorio
                                propsFormik={propsFormik}
                                classeTooltip={'tooltip-input-modal'} />
                            <Atalho formik={propsFormik} salvando={salvando} />
                        </div>
                        <div className='direita container-botoes'>
                            <BotaoPadrao texto={msgBotao} />
                        </div>
                    </Form>}
                </Formik>
            </ModalCadastro>
        </>)
}

export default Cadastro